import React from 'react';
import { Card, CardContent, Divider, Typography } from '@mui/joy';

const ClientProfileCard = ({ profile }) => (
    <Card variant="outlined" sx={{ mb: 4 }}>
        <CardContent>
            <Typography level="title-lg">{profile.name}</Typography>
            <Typography level="body-sm" textColor="neutral.500">{profile.email}</Typography>
            <Divider sx={{ my: 1 }} />
            <Typography level="body-xs">Client ID: {profile.id}</Typography>
            <Typography level="body-xs">Log level: {profile.log_level}</Typography>
            <Typography level="body-xs">Created At: {profile.created_at}</Typography>
            <Typography level="body-xs">Deleted At: {profile.deleted_at || '—'}</Typography>
        </CardContent>
    </Card>
);

export default ClientProfileCard;